import React, { useEffect, useState } from "react";
import {
  Search,
  SlidersHorizontal,
  Plus,
  Heart,
  Package,
  Eye,
  Trash2,
  Save,
  ChevronDown,
  Check,
  Store,
  User2,
  TriangleAlert,
  RotateCcw,
} from "lucide-react";
import { getAllCustomerSerachStoreOwner, getAllCustomerSerachStoreWiseList } from "../../services/storeOwnerOrderServices";
import { notify } from "../../components/Common/Alerts";
import Utils from "../../utils";
import { getCustomerProductList } from "../../services/customerServices";
import CONFIG from "../../config";
import { decryptData } from "../../utils/crypto";
import Select from "react-select";
import {
  createCustomerFavProduct,
  customerFavProductRemove,
  customerFavProductSingleRemove,
  customerFavProductToggleRemove,
  getCustomerFavProductList,
} from "../../services/customerFavouriteService";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ManageProducts = () => {
  const storedData = JSON.parse(localStorage.getItem(CONFIG.login_data));
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [activeTab, setActiveTab] = useState("favourites");
  const [searchProduct, setSearchProduct] = useState("");
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const [customerList, setCustomerList] = useState([]);
  const [products, setProducts] = useState([]);
  const [btnLoading, setBtnLoading] = useState(false);
  const [favProductsList, setFavProductsList] = useState([]);
  const [showClearModal, setShowClearModal] = useState(false);
  const [showUnFavModal, setShowUnFavModal] = useState(false);
  const [selectedProductId, setSelectedProductId] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);

 

  useEffect(() => {
    const data = { search: "", page: "", limit: "" };

    getAllCustomerSerachStoreWiseList(data)
      .then((response) => {
        const decrypted = decryptData(response.data.data);
        setCustomerList(decrypted.data || []);
      })
      .catch((err) => {
        notify.error(Utils.getErrorMessage(err));
      });
  }, []);

  const customerOptions = customerList.map((customer) => ({
    value: customer.id,
    label: customer.name,
    mobile: customer.mobile,
    image: customer.profile_image,
  }));

  useEffect(() => {
    const data = {
      store_id: storedData?.active_store_id,
      category_ids: [],
      search: "",
      page: "",
      limit: 50,
    };

    getCustomerProductList(data)
      .then((response) => {
        const decrypted = decryptData(response.data.data);
        const formatted = (decrypted.data || []).map((p) => ({
          ...p,
          isFavourite: p.isFavourite ?? false,
        }));
        setProducts(formatted);
      })
      .catch((err) => {
        notify.error(Utils.getErrorMessage(err));
      });
  }, []);

  const fetchFavouriteProducts = async () => {
    if (!selectedCustomer) return;

    try {
      const data = {
        store_id: storedData?.active_store_id,
        customer_id: selectedCustomer?.value,
        search: "",
        page: "",
        limit: 50,
      };

      const response = await getCustomerFavProductList(data);
      const decrypted = decryptData(response.data.data);

      setFavProductsList(decrypted.data);
    } catch (err) {
      notify.error(Utils.getErrorMessage(err));
    }
  };

  useEffect(() => {
    fetchFavouriteProducts();
  }, [selectedCustomer]);

  const toggleFavourite = (product) => {
    if (product.isFavourite) {
      // Already saved in database -> Show confirmation popup
      if (product.favourite_id) {
        setSelectedProduct(product);
        setShowUnFavModal(true);
      } else {
        // Not saved yet -> Remove directly
        setProducts((prev) =>
          prev.map((p) =>
            p.id === product.id ? { ...p, isFavourite: false } : p,
          ),
        );
      }
    } else {
      // Add favourite locally
      setProducts((prev) =>
        prev.map((p) =>
          p.id === product.id ? { ...p, isFavourite: true } : p,
        ),
      );
    }
  };

  const filteredProducts = products
    .filter((p) => p.name.toLowerCase().includes(searchProduct.toLowerCase()))
    .filter((p) => {
      if (activeTab === "favourites") return p.isFavourite;
      return true;
    });

  useEffect(() => {
    setProducts((prev) =>
      prev.map((product) => {
        const matchedFav = favProductsList.find(
          (fav) => String(fav.id) === String(product.id),
        );
        return {
          ...product,
          isFavourite: !!matchedFav,
          favourite_id: matchedFav?.favourite_id || null,
        };
      }),
    );
  }, [favProductsList]);

  const favouriteCount = products.filter((p) => p.isFavourite).length;
  const totalProducts = products.length;

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedCustomer) {
      notify.error("Please select customer");
      setBtnLoading(false);
      return;
    }

    if (filteredProducts.length === 0) {
      notify.error("At least one favourite product choose");
      setBtnLoading(false);
      return;
    }

    setBtnLoading(true);

    const payload = {
      customer_id: selectedCustomer?.value,
      store_id: storedData?.active_store_id,

      products: filteredProducts
        .filter((item) => item.isFavourite)
        .map((item) => ({
          favourite_id: item.favourite_id || null,
          product_id: item.id,
          is_visible: true,
          is_favourite: item.isFavourite,
        })),
    };

    try {
      const response = await createCustomerFavProduct(payload);
      const decrypted = decryptData(response.data.data);
      notify.success(decrypted.message);
      await fetchFavouriteProducts();
      navigate("/fav-product");
      setActiveTab("favourites");
    } catch (err) {
      notify.error(Utils.getErrorMessage(err));
    } finally {
      setBtnLoading(false);
    }
  };

  const handleClearAll = async () => {
    const productIds = favProductsList.map((item) => item?.id);

    const payload = {
      customer_id: selectedCustomer?.value,
      product_ids: productIds,
    };

    try {
      const res = await customerFavProductToggleRemove(payload);
      const decrypted = decryptData(res.data);
      setProducts((prev) =>
        prev.map((item) => ({
          ...item,
          isFavourite: false,
          favourite_id: null,
        })),
      );

      setFavProductsList([]);
      setSelectedCustomer("");
      setShowClearModal(false);

      notify.success("All favourites removed successfully.");
    } catch (err) {
      notify.error(Utils.getErrorMessage(err));
    }
  };

  const confirmUnFavourite = async () => {
    try {
      setBtnLoading(true);

      const payload = {
        customer_id: selectedCustomer?.value,
        store_id: storedData?.active_store_id,
        products: [
          {
            favourite_id: selectedProduct.favourite_id || null,
            product_id: selectedProduct.id,
            is_visible: true,
            is_favourite: false,
          },
        ],
      };

      const response = await customerFavProductSingleRemove(payload);
      const decrypted = decryptData(response.data.data);
      notify.success("Product has been removed from your favourites.");

      setProducts((prev) =>
        prev.map((p) =>
          p.id === selectedProduct.id ? { ...p, isFavourite: false } : p,
        ),
      );
      await fetchFavouriteProducts();
      setShowUnFavModal(false);
      setSelectedProduct(null);
    } catch (err) {
      notify.error(Utils.getErrorMessage(err));
    } finally {
      setBtnLoading(false);
    }
  };

  const cancelUnFavourite = () => {
    setShowUnFavModal(false);
    setSelectedProduct(null);
  };

  return (
    <div className="w-full bg-[#fcfbfa] py-5 px-4 sm:px-6 md:px-8 font-sans text-slate-700 antialiased">
      <div
        className="w-full mx-auto space-y-5"
        style={{ marginBottom: "68px" }}
      >
        <div className="bg-white rounded-2xl border border-slate-200 shadow-sm px-6 py-5 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">
          {/* Left Side */}
          <div className="flex items-center gap-4">
            <div className="h-14 w-14 rounded-xl bg-orange-50 flex items-center justify-center border border-orange-100">
              <Store className="w-6 h-6 text-orange-500" />
            </div>

            <div>
              <h2 className="text-xl font-bold text-slate-900">
                {t("manageFavouriteProducts")}
              </h2>

              <p className="text-sm text-slate-500 mt-1">
                Select a customer to manage favourite products.
              </p>
            </div>
          </div>

          {/* Right Side */}
          <div className="flex flex-col sm:flex-row items-end gap-3">
            <div className="min-w-[320px]">
              <label className="flex items-center gap-2 text-sm font-semibold text-slate-700 mb-2">
                <User2 size={16} className="text-orange-500" />
                {t("selectCustomer")}
              </label>

              <Select
                options={customerOptions}
                value={selectedCustomer}
                placeholder="Search customer..."
                onChange={async (selected) => {
                  setSelectedCustomer(selected);

                  if (!selected) {
                    setFavProductsList([]);
                    return;
                  }

                  try {
                    const payload = {
                      customer_id: selected.value,
                      store_id: storedData?.active_store_id,
                    };

                    const response = await getCustomerFavProductList(payload);
                    const decrypted = decryptData(response.data.data);

                    setFavProductsList(decrypted.data || []);
                  } catch (error) {
                    console.log(error);
                  }
                }}
                isSearchable
                menuPortalTarget={document.body}
                styles={{
                  control: (base, state) => ({
                    ...base,
                    minHeight: 48,
                    borderRadius: 12,
                    borderColor: state.isFocused ? "#f97316" : "#e2e8f0",
                    boxShadow: state.isFocused
                      ? "0 0 0 3px rgba(249,115,22,.15)"
                      : "none",
                    "&:hover": {
                      borderColor: "#f97316",
                    },
                  }),

                  placeholder: (base) => ({
                    ...base,
                    color: "#94a3b8",
                  }),

                  valueContainer: (base) => ({
                    ...base,
                    padding: "2px 12px",
                  }),

                  menu: (base) => ({
                    ...base,
                    borderRadius: 14,
                    overflow: "hidden",
                    zIndex: 9999,
                  }),

                  option: (base, state) => ({
                    ...base,
                    padding: "12px",
                    background: state.isFocused
                      ? "#fff7ed"
                      : state.isSelected
                        ? "#ffedd5"
                        : "#fff",
                    color: "#0f172a",
                    cursor: "pointer",
                  }),

                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 9999,
                  }),
                }}
                formatOptionLabel={(data) => (
                  <div className="flex items-center gap-3">
                    {data.profile_image ? (
                      <img
                        src={data.profile_image}
                        className="w-10 h-10 rounded-full object-cover border"
                      />
                    ) : (
                      <div className="w-10 h-10 rounded-full bg-orange-100 flex items-center justify-center">
                        <User2 size={18} className="text-orange-500" />
                      </div>
                    )}

                    <div>
                      <div className="font-medium text-slate-800">
                        {data.label}
                      </div>

                      <div className="text-xs text-slate-500">
                        {data.mobile}
                      </div>
                    </div>
                  </div>
                )}
              />
            </div>

            <button
              type="button"
              disabled={!selectedCustomer}
              onClick={() => {
                setSelectedCustomer(null);
                setFavProductsList([]);
              }}
              className="h-12 px-5 rounded-xl border border-slate-200 bg-white text-slate-600 flex items-center gap-2 hover:bg-orange-50 hover:border-orange-300 hover:text-orange-600 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <RotateCcw size={17} />
              Reset
            </button>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          <div className="bg-white p-4 rounded-xl border border-slate-100 shadow-sm flex items-center space-x-3.5">
            <div className="p-2.5 bg-indigo-50 text-indigo-600 rounded-lg">
              <Package className="w-5 h-5" />
            </div>
            <div>
              <p className="text-[10px] font-bold text-slate-400 uppercase tracking-wider">
                {t("totalProducts")}
              </p>
              <p className="text-xl font-bold text-slate-900 leading-tight mt-0.5">
                {totalProducts}
              </p>
            </div>
          </div>

          <div className="bg-orange-50/20 p-4 rounded-xl border border-orange-100/70 flex items-center space-x-3.5">
            <div className="p-2.5 bg-orange-500 text-white rounded-lg shadow-sm">
              <Heart className="w-5 h-5 fill-current" />
            </div>
            <div>
              <p className="text-[10px] font-bold text-orange-500 uppercase tracking-wider">
                {t("favouriteProduct")}
              </p>
              <p className="text-xl font-bold text-orange-600 leading-tight mt-0.5">
                {favouriteCount}
              </p>
            </div>
          </div>
        </div>

        <div className="border-b border-slate-200 flex space-x-2 overflow-x-auto scrollbar-none">
          <button
            onClick={() => setActiveTab("favourites")}
            className={`flex items-center space-x-2 px-3 py-2.5 text-xs font-bold border-b-2 transition-all whitespace-nowrap ${activeTab === "favourites" ? "border-orange-500 text-orange-600" : "border-transparent text-slate-400 hover:text-slate-600"}`}
          >
            <Heart
              className={`w-4 h-4 ${activeTab === "favourites" ? "fill-current" : ""}`}
            />
            <span>
              {" "}
              ❤️ {t("favourite")} ({favouriteCount})
            </span>
          </button>
          <button
            onClick={() => setActiveTab("all")}
            className={`flex items-center space-x-2 px-3 py-2.5 text-xs font-bold border-b-2 transition-all whitespace-nowrap ${activeTab === "all" ? "border-orange-500 text-orange-600" : "border-transparent text-slate-400 hover:text-slate-600"}`}
          >
            <Package className="w-4 h-4" />
            <span>
              📦 {t("allProducts")} ({totalProducts})
            </span>
          </button>
        </div>

        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
          {/* Search */}
          <div className="w-full lg:max-w-md">
            <div className="relative">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
              <input
                type="text"
                placeholder="Search catalog products..."
                value={searchProduct}
                onChange={(e) => setSearchProduct(e.target.value)}
                className="w-full h-10 rounded-lg border border-slate-200 bg-white pl-10 pr-3 text-sm focus:border-orange-500 focus:outline-none"
              />
            </div>
          </div>

          {/* Buttons */}
          <div className="flex flex-col sm:flex-row gap-3 w-full lg:w-auto">
            <button
              onClick={() => setActiveTab("all")}
              className="flex items-center justify-center gap-2 h-10 px-5 rounded-lg bg-orange-500 hover:bg-orange-600 text-white text-sm font-medium shadow-sm whitespace-nowrap"
            >
              <Plus className="w-4 h-4" />
              <span>{t("addFavouriteProducts")}</span>
            </button>
            {favouriteCount > 0 && (
              <button
                type="button"
                onClick={handleSubmit}
                className="flex items-center justify-center gap-2 h-10 px-5 rounded-lg bg-orange-500 hover:bg-orange-600 text-white text-sm font-medium shadow-sm whitespace-nowrap"
              >
                <Save className="w-4 h-4" />
                <span>{t("saveFavouriteProduct")}</span>
              </button>
            )}
          </div>
        </div>
        <div className="bg-white rounded-xl border border-slate-100 shadow-sm overflow-hidden">
          <div className="hidden md:block overflow-x-auto">
            <div className="w-full overflow-x-auto rounded-xl border border-slate-100 bg-white shadow-sm">
              <table className="w-full text-left border-collapse table-auto min-w-[600px]">
                <thead>
                  <tr className="bg-slate-50/70 border-b border-slate-100 text-[11px] font-bold uppercase tracking-wider text-slate-400">
                    <th className="py-3.5 px-6">{t("product")}</th>
                    <th className="py-3.5 px-5">{t("category")}</th>
                    <th className="py-3.5 px-5">{t("price")}</th>
                    <th className="py-3.5 px-5 text-center w-28">
                      {t("favourite")}
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-100 text-xs">
                  {filteredProducts?.map((product) => (
                    <tr
                      key={product.id}
                      className="hover:bg-slate-50/40 transition-colors group"
                    >
                      <td className="py-3 px-6">
                        <div className="flex items-center space-x-3.5">
                          📦{" "}
                          <div>
                            <p className="font-bold text-slate-900 text-sm tracking-wide">
                              {" "}
                              {product.name} ({product.unit_qty}
                              {product?.unit_short_name})
                            </p>
                          </div>
                        </div>
                      </td>

                      <td className="py-3 px-5 text-slate-500 font-medium align-middle">
                        {product.category_name}
                      </td>

                      <td className="py-3 px-5 font-bold text-slate-900 text-sm align-middle">
                        ₹{product.selling_price}
                      </td>

                      <td className="py-3 px-5 text-center align-middle">
                        <div className="flex items-center justify-center">
                          <button
                            onClick={() => toggleFavourite(product)}
                            className={`w-9 h-9 rounded-full flex items-center justify-center transition-all duration-200 outline-none ${
                              product.isFavourite
                                ? "bg-orange-50 hover:bg-orange-100/80 shadow-sm"
                                : "bg-slate-50 hover:bg-slate-100"
                            }`}
                            aria-label={
                              product.isFavourite
                                ? "Remove from favourites"
                                : "Add to favourites"
                            }
                          >
                            <Heart
                              className={`w-4 h-4 transition-transform duration-200 active:scale-90 ${
                                product.isFavourite
                                  ? "text-orange-500 fill-orange-500"
                                  : "text-slate-300 group-hover:text-slate-400"
                              }`}
                            />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}

                  {filteredProducts?.length === 0 && (
                    <tr>
                      <td
                        colSpan="5"
                        className="text-center p-6 text-slate-400"
                      >
                        {t("noProductsFound")}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {/* Mobile View */}
          <div className="md:hidden divide-y divide-slate-100 bg-white">
            {filteredProducts?.map((product) => (
              <div
                key={product.id}
                className="p-4 relative hover:bg-slate-50/30 transition-colors"
              >
                <div className="flex justify-between items-start gap-4">
                  {/* Left Side: Icon, Name, and Category Tag */}
                  <div className="flex items-start space-x-3 flex-1 min-w-0">
                    <span className="text-lg mt-0.5 flex-shrink-0">📦</span>
                    <div className="min-w-0 flex-1">
                      <p className="font-semibold text-slate-800 text-sm leading-tight break-words">
                        {product.name} ({product.unit_qty}
                        {product?.unit_short_name})
                      </p>
                      <div className="mt-2">
                        <span className="inline-block text-[10px] font-semibold text-slate-500 bg-slate-100 px-2 py-0.5 rounded-md tracking-wider uppercase">
                          {product.category_name}
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Right Side: Price & Heart Action Stack */}
                  <div className="flex flex-col items-end space-y-3 flex-shrink-0">
                    <p className="font-bold text-slate-900 text-base">
                      ₹{product.selling_price}
                    </p>

                    <button
                      onClick={() => toggleFavourite(product.id)}
                      className={`w-9 h-9 rounded-full flex items-center justify-center transition-all duration-200 border outline-none ${
                        product.isFavourite
                          ? "bg-rose-50 border-rose-100 shadow-sm scale-105"
                          : "bg-slate-50 border-slate-100 text-slate-400 hover:text-slate-500"
                      }`}
                      aria-label={
                        product.isFavourite
                          ? "Remove from favourites"
                          : "Add to favourites"
                      }
                    >
                      <Heart
                        className={`w-4 h-4 transition-all duration-200 active:scale-75 ${
                          product.isFavourite
                            ? "text-rose-500 fill-rose-500"
                            : "text-slate-400"
                        }`}
                      />
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="flex flex-col sm:flex-row gap-3 sm:items-center justify-between pt-1">
          <p className="text-xs text-slate-400 text-center sm:text-left">
            <span className="font-semibold text-slate-600"></span>
            <span className="font-semibold text-slate-600"></span>
          </p>
          <div className="flex items-center gap-3">
            {favouriteCount > 0 && (
              <button
                type="button"
                onClick={() => setShowClearModal(true)}
                className="flex-1 sm:flex-initial flex items-center justify-center space-x-2 border border-orange-200 text-orange-600 h-9 px-4 rounded-lg text-xs font-bold hover:bg-orange-50 transition-colors"
              >
                <Trash2 className="w-4 h-4" />
                <span>{t("clearAll")}</span>
              </button>
            )}

            {favouriteCount > 0 && (
              <button
                type="button"
                onClick={handleSubmit}
                className="flex-1 sm:flex-initial flex items-center justify-center space-x-2 bg-orange-500 hover:bg-orange-600 text-white h-9 px-4 rounded-lg text-xs font-bold shadow-sm transition-colors"
              >
                <Save className="w-4 h-4" />
                <span>{t("saveFavouriteProduct")}</span>
              </button>
            )}
          </div>
        </div>
      </div>

      {showClearModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
          <div className="bg-white rounded-xl shadow-xl w-[400px] p-6">
            <h2 className="text-lg font-semibold">Clear All Favourites</h2>

            <p className="mt-3 text-sm text-gray-600">
              Are you sure you want to remove all favourite products?
            </p>

            <div className="flex justify-end gap-3 mt-6">
              <button
                onClick={() => setShowClearModal(false)}
                className="px-4 py-2 rounded-lg border"
              >
                No
              </button>

              <button
                onClick={handleClearAll}
                className="px-4 py-2 rounded-lg bg-red-500 text-white hover:bg-red-600"
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      )}

      {showUnFavModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
          <div className="w-[400px] rounded-xl bg-white p-6 shadow-xl">
            <div className="flex items-center gap-3">
              <div className="rounded-full bg-red-100 p-2">
                <TriangleAlert className="h-6 w-6 text-red-600" />
              </div>

              <h2 className="text-lg font-semibold">Remove Favourite</h2>
            </div>

            <p className="mt-4 text-sm text-gray-600">
              Are you sure you want to remove this product from your favourites?
            </p>

            <div className="mt-6 flex justify-end gap-3">
              <button
                onClick={cancelUnFavourite}
                className="rounded-lg border px-4 py-2"
              >
                No
              </button>

              <button
                onClick={confirmUnFavourite}
                className="rounded-lg bg-red-500 px-4 py-2 text-white hover:bg-red-600"
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ManageProducts;
